@if (addedTags.length > 0) {
  <pp-dashlet-activity-tags-list
    ppLabel="{{ 'added' | ppTranslate }}"
    [ppTags]="addedTags"
  ></pp-dashlet-activity-tags-list>
}

@if (removedTags.length > 0) {
  <pp-dashlet-activity-tags-list
    ppLabel="{{ 'removed' | ppTranslate }}"
    [ppTags]="removedTags"
  ></pp-dashlet-activity-tags-list>
}
